import { Component, Prop, Watch } from "vue-property-decorator";
import { InputMessage, InputOption } from "../../../../../models/Input";
import InputDefaultForm from "../../../default/InputDefaultForm";

@Component
export default class InputEmailForm extends InputDefaultForm {
	@Prop()
	public dataInputOption!: InputOption;

	@Watch("dataInputOption.trigger")
	public checkValidation(): void {
		this.checkValidationDefault();

		if (this.dataInputOption.error) {
			return;
		}

		if (this.dataInputOption.vmodel !== "") {
			this.success = false;
			this.dataInputOption.error = false;

			const emailRegex = new RegExp("^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,4}$", "g");

			if (emailRegex.test(this.dataInputOption.vmodel)) {
				this.success = true;
			} else {
				this.dataInputOption.error = true;
				this.dataInputOption.message = InputMessage.EmailInvalid;
			}
		}
	}

	public keydown(): void {
		this.$emit("changed");
	}
}



// WEBPACK FOOTER //
// ./src/shared/components/forms/extended/InputText/InputEmailForm/InputEmailForm.ts